export default "__VITE_PUBLIC_ASSET__4f3cac43__"